import React from 'react';
import AutoSizeTitle from '../../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../../components/individualInformHeader/individualInformHeader';
import ResumeBarChartSelfcare from '../../../graphics/selfcare/resumeBarChartSelfcare';
import ScoreCardSelfcare from '../../../components/selfcare/scoreCardSelfcare';
import {
    SELFCARE_DIMENSION_DEFS,
    getDimensionsEntries,
    getGlobalNarrative,
    getVisibleSelfcareGlobalScore,
} from '../selfcareReportLogic';
import '../resumeSelfcare.css';

const DIMENSION_LEGEND = SELFCARE_DIMENSION_DEFS
    .slice()
    .sort((a, b) => a.radarOrder - b.radarOrder)
    .map((dimension) => ({
        code: dimension.code,
        label: dimension.reportTitle.replace(/^D\d\s+/, ''),
    }));

const PageResumeSelfcare_1 = ({ selectedEvaluation, individualResult, pageNumber, orgLogo }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const dimensionsEntries = getDimensionsEntries(individualResult, { order: 'radar' });

    const dimensionsObj = dimensionsEntries.reduce((acc, dim) => {
        acc[dim.key] = dim;
        return acc;
    }, {});
    const visibleGlobalScore = getVisibleSelfcareGlobalScore(individualResult);

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <div className="selfcare-resume-section">
                        <div className="selfcare-resume-title">Resumen</div>

                        <div className="selfcare-resume-hero">
                            <div className="selfcare-resume-chart-panel">
                                <div className="selfcare-resume-bars">
                                    <ResumeBarChartSelfcare data={dimensionsObj} yAxisWidth={30} />
                                </div>
                            </div>
                            <div className="selfcare-resume-side-panel">
                                <ScoreCardSelfcare value={visibleGlobalScore} />
                            </div>
                        </div>

                        <div className="selfcare-dimension-code-legend">
                            {DIMENSION_LEGEND.map((dimension) => (
                                <div key={dimension.code} className="selfcare-dimension-code-legend-item">
                                    <span className="selfcare-dimension-code-legend-code">{dimension.code}</span>
                                    <span className="selfcare-dimension-code-legend-text">{dimension.label}</span>
                                </div>
                            ))}
                        </div>

                        <div className="selfcare-resume-legend">
                            <div className="selfcare-resume-legend-left">
                                <div className="selfcare-resume-tier">
                                    <span className="selfcare-resume-dot" style={{ backgroundColor: '#1E8449' }} />
                                    <span className="selfcare-resume-range">80-100%</span>
                                    <span className="selfcare-resume-tier-name">RIESGO BAJO</span>
                                </div>
                                <div className="selfcare-resume-tier">
                                    <span className="selfcare-resume-dot" style={{ backgroundColor: '#F9A825' }} />
                                    <span className="selfcare-resume-range">65-79%</span>
                                    <span className="selfcare-resume-tier-name">RIESGO MODERADO</span>
                                </div>
                                <div className="selfcare-resume-tier">
                                    <span className="selfcare-resume-dot" style={{ backgroundColor: '#E67E22' }} />
                                    <span className="selfcare-resume-range">50-64%</span>
                                    <span className="selfcare-resume-tier-name">RIESGO ALTO</span>
                                </div>
                                <div className="selfcare-resume-tier">
                                    <span className="selfcare-resume-dot" style={{ backgroundColor: '#C0392B' }} />
                                    <span className="selfcare-resume-range">0-49%</span>
                                    <span className="selfcare-resume-tier-name">RIESGO CRÍTICO</span>
                                </div>
                            </div>

                            <div className="selfcare-resume-legend-right">
                                <div className="selfcare-resume-tier-desc">
                                    <strong>Riesgo Bajo:</strong> El nivel de autocuidado es consistente y estable. Las prácticas físicas, emocionales y cognitivas se mantienen en rango seguro y protegen la operación.
                                </div>
                                <div className="selfcare-resume-tier-desc">
                                    <strong>Riesgo Moderado:</strong> El autocuidado es adecuado en general, aunque ya aparecen brechas puntuales que conviene corregir antes de que se acumulen.
                                </div>
                                <div className="selfcare-resume-tier-desc">
                                    <strong>Riesgo Alto:</strong> Existen variaciones relevantes en hábitos de autocuidado. Estas áreas requieren acompañamiento focalizado para estabilizar comportamientos seguros.
                                </div>
                                <div className="selfcare-resume-tier-desc">
                                    <strong>Riesgo Crítico:</strong> El autocuidado presenta brechas significativas que elevan la probabilidad de error humano. Este nivel demanda intervención inmediata y seguimiento cercano.
                                </div>
                            </div>
                        </div>

                        <div className="selfcare-resume-narrative">
                            {getGlobalNarrative(visibleGlobalScore)}
                        </div>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResumeSelfcare_1;
